import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

import {
  MutationWithArrayInput,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import {
  HRService,
  caseManagementUrl,
  setupManagementUrl,
} from "../../../config";
import DynamicForm from "../../../data/Axios/DynamicForm";
import { imprestApplicationsForms } from "../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import { allDisbursementType } from "../../../data/Queries/HRmanagement/leavemanagement";
import { allCasesView } from "../../../data/Axios/queries";

const base_url = HRService.uri;

const ImprestApplicationForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [disbursementTypes, setDisbursementTypes] = useState([]);
  const [loading, setLoading] = useState(true);
const [showCases, setShowCases] = useState(
  props.data ? props.data.caseRelated === 1 : false
);
  const [cases, setCases] = useState([]);
  const initialValues = {
    disbursementTypeId: props.data ? props.data.disbursementTypeId : "",
    amount: props.data ? props.data.amount : "",
    title: props.data ? props.data.title : "",
    description: props.data ? props.data.description : "",
    caseRelated: props.data
      ? props.data.isPettyCash === 1
        ? true
        : false
      : false,
    caseRelated: props.data
      ? props.data.caseRelated === 1
        ? true
        : false
      : false,
  };

  async function fetchDisbursementTypes() {
    try {
      const data = await graphqlQuery(
        allDisbursementType,
        setupManagementUrl.uri
      );
      if (data) {
        setDisbursementTypes(data);
      }
      const casesData = await graphqlQuery(allCasesView, caseManagementUrl.uri);
      if (casesData) setCases(casesData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchDisbursementTypes();
  }, []);
  const caseOptions = cases
    ? cases.map((caseItem) => ({
        value: caseItem.id,
        label: caseItem.title,
      }))
    : [];
  const disbursementTypeOptions = disbursementTypes
    ? disbursementTypes.map((type) => ({
        value: type.id,
        label: type.type,
      }))
    : [];

  const fields = [
    {
      name: "disbursementTypeId",
      label: "Disbursement Type",
      type: "select",
      options: disbursementTypeOptions.map((type) => ({
        value: type.value,
        label: type.label,
      })),
      gridColumn: "span 2",
      required: true,
    },
    ...imprestApplicationsForms,
    ...(showCases
      ? [
          {
            name: "caseId",
            label: "Cases",
            type: "select",
            options: caseOptions.map((caseItem) => ({
              value: caseItem.value,
              label: caseItem.label,
            })),
            required: false,
            gridColumn: "span 2",
          },
        ]
      : []),
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        disbursementTypeId,
        isPettyCash,
        amount,
        title,
        description,
        caseRelated,
      } = values;
      //const caseRelated = values.caseRelated === 0 ? true : false;
      const mutationData = {
        disbursementTypeId,
        amount,
        title,
        isPettyCash,
        description,
        caseId: values.caseId ? values.caseId : null,
        caseRelated,
      };
      if (props.isEditing) {
        mutationData.id = props.data.id;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing
          ? "updateImprestApplication"
          : "createImprestApplication",
        mutationData,
        "imprest",
        base_url
      );

      if (Object.values(response)[0]) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Imprest application created successfully.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };
  const handleFieldChange = async (field, value) => {
    if (field.name === "caseRelated") {
      if (value === true) {
        setShowCases(true);
      } else {
        setShowCases(false);
      }
    }
  };
  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onFieldChange={handleFieldChange}
      onSubmit={handleSubmit}
      title={
        props.isEditing
          ? "Update Imprest Application"
          : "Create Imprest Application"
      }
      subtitle={
        props.isEditing
          ? "Fill out the form below to update imprest application."
          : "Fill out the form below to apply for imprest."
      }
    />
  );
};

export default ImprestApplicationForm;
